import React from 'react';

import { ScrollPanel } from 'primereact/scrollpanel';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';

const DoctorCard = ({ doctor, isAssigned, onToggleAssign }) => {

  // Local state to manage the assigned status
  // const [isAssigned, setIsAssigned] = useState(doctor.is_assigned);

  // Update local state when the doctor prop changes
  // useEffect(() => {
  //   setIsAssigned(doctor.is_assigned);
  // }, [doctor.is_assigned]);

  const toggleCheckbox = () => {
    // const newAssignedStatus = !isAssigned; // Toggle the current state
    // setIsAssigned(newAssignedStatus); // Update local state
    // onToggleAssign(doctor.id, newAssignedStatus);
    onToggleAssign(doctor.id, isAssigned);
  };

  return (
    <div className="doctor-card flex flex-row justify-content-between align-items-center cursor-pointer" onClick={toggleCheckbox}>
      <div className="doctor-card-header flex-grow-1 align-items-center">

        <div className="mr-2 checkbox-container">
          <Checkbox
            inputId={`doctor-${doctor.id}`}
            checked={isAssigned}
            aria-label={`Asignar ${doctor.name}`}
          />
        </div>

        <figure className="m-0 mr-2">
          <img src={doctor.profileImage} alt={doctor.name} className="round" />
        </figure>

        <div className="flex-grow-1 doctor-name">
          <span className="font-bold block">{doctor.name}</span>
          <span className="block">{doctor.specialities.map(s => s.name).join(', ')}</span>
          {/* <span><Rating value={doctor.averageRating} readOnly cancel={false} /></span> */}
        </div>
        
        <div>
          <Button 
              className={`font-normal ${isAssigned ? 'button-assigned' : 'button-unassigned'}`} 
              label={isAssigned ? "REMOVER" : "SELECCIONAR"} 
              size="small" 
              aria-label={`Toggle assignment for ${doctor.name}`}
          />
        </div>
      </div>
    </div>
  );
};


const DoctorList = ({ doctors, assignedDoctors, onToggleAssign }) => {
  return (
    <ScrollPanel className='doctor-list-scroll'>
      <div className="card-container">
        {doctors.map(doctor => (
          <DoctorCard
            key={doctor.id}
            doctor={doctor}
            isAssigned={assignedDoctors.includes(doctor.id)}
            onToggleAssign={onToggleAssign}
          />
        ))}
      </div>
    </ScrollPanel>
  );
};

export default DoctorList;